import { render, staticRenderFns } from "./ImagePreviewLightbox.vue?vue&type=template&id=31472b0a&scoped=true&"
import script from "./ImagePreviewLightbox.vue?vue&type=script&lang=js&"
export * from "./ImagePreviewLightbox.vue?vue&type=script&lang=js&"
import style0 from "./ImagePreviewLightbox.vue?vue&type=style&index=0&id=31472b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31472b0a",
  null
  
)

export default component.exports